import script from "./BadLocaleIds.vue?vue&type=script&setup=true&lang=js"
export * from "./BadLocaleIds.vue?vue&type=script&setup=true&lang=js"

import "./BadLocaleIds.vue?vue&type=style&index=0&id=3e619c1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e619c1d"]])

export default __exports__